import {
  INCOMING_INSTRUCTOR_CONNECTION_DEMAND,
  INSTRUCTOR_CONNECTION,
  ORGANIZATION,
  ORGANIZATION_ALL,
  ORGANIZATION_DEMAND,
} from '../reducer/organization';
import request from '../request';
import { changeSelectedOrg, getAllPermissions } from './PermissionAction';
import store from '../store';

let organizationDemandURL = '/manage/organization/registration-demands/';

let organizationAllURL = '/manage/organizations/all/';

export function organizationDemandCreate(data) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_DEMAND.loading });

      let res = await request.post(organizationDemandURL, data);
      dispatch({ type: ORGANIZATION_DEMAND.create, payload: res.data });
    } catch (e) {
      dispatch({ type: ORGANIZATION_DEMAND.error, payload: e.response.data });
    }
  };
}

export function organizationDemandList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_DEMAND.list.loading });

      let res = await request.get(organizationDemandURL, { params: { ...params, page_size: 5 } });
      let { results, count } = res.data;
      dispatch({ type: ORGANIZATION_DEMAND.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: ORGANIZATION_DEMAND.list.error, payload: e.response?.data });
    }
  };
}

export function organizationDemandGet(id) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_DEMAND.loading });

      let res = await request.post(`${organizationDemandURL}${id}/`);
      dispatch({ type: ORGANIZATION_DEMAND.get, payload: res.data });
    } catch (e) {
      dispatch({ type: ORGANIZATION_DEMAND.error, payload: e.response.data });
    }
  };
}

export function organizationDemandUpdate(id, data) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_DEMAND.loading });

      let res = await request.patch(`${organizationDemandURL}${id}/`, data);

      dispatch({ type: ORGANIZATION_DEMAND.update, payload: res.data });
    } catch (e) {
      dispatch({ type: ORGANIZATION_DEMAND.error, payload: e.response.data });
    }
  };
}

export function organizationAllList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_ALL.list.loading });

      let res = await request.get(organizationAllURL, { params });
      let { results, count } = res.data;
      dispatch({ type: ORGANIZATION_ALL.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: ORGANIZATION_ALL.list.error, payload: e.response.data });
    }
  };
}

/**########################## Organization Resource ##########################*/
export function organizationGet(id) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION.loading });

      let res = await request.get(`/manage/organizations/${id}/`);
      dispatch({ type: ORGANIZATION.get, payload: res.data });
    } catch (e) {
      dispatch({ type: ORGANIZATION.error, payload: e.response.data });
    }
  };
}

export function organizationUpdate(id, data) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION.loading });

      let res = await request.patch(`/manage/organizations/${id}/`, data);
      dispatch({ type: ORGANIZATION.update, payload: res.data });

      dispatch(changeSelectedOrg({ ...store.getState().permission?.selectedOrg, name: res.data.name }));
    } catch (e) {
      dispatch({ type: ORGANIZATION.error, payload: e.response.data });
    }
  };
}

/**########################## Incoming instructor connection demands resource ##########################*/
export function incomingInstructorConnectionDemandList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: INCOMING_INSTRUCTOR_CONNECTION_DEMAND.list.loading });

      let res = await request.get('/manage/organization/incoming-instructor-connection-demands/', {
        params: {
          ...params,
          status: 1,
        },
      });
      let { results, count } = res.data;
      dispatch({ type: INCOMING_INSTRUCTOR_CONNECTION_DEMAND.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: INCOMING_INSTRUCTOR_CONNECTION_DEMAND.list.error, payload: e.response.data });
    }
  };
}

export function incomingInstructorConnectionDemandUpdate(id, data) {
  return async dispatch => {
    try {
      dispatch({ type: INCOMING_INSTRUCTOR_CONNECTION_DEMAND.loading });

      let res = await request.patch(`/manage/organization/incoming-instructor-connection-demands/${id}/status/`, data);
      dispatch({ type: INCOMING_INSTRUCTOR_CONNECTION_DEMAND.update, payload: res.data });
    } catch (e) {
      dispatch({ type: INCOMING_INSTRUCTOR_CONNECTION_DEMAND.error, payload: e.response.data });
    }
  };
}

/**########################## Instructor connection resource ##########################*/
export function instructorConnectionList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR_CONNECTION.list.loading });

      let res = await request.get('/manage/organization/instructor-connections/', { params });
      let { results, count } = res.data;
      dispatch({ type: INSTRUCTOR_CONNECTION.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: INSTRUCTOR_CONNECTION.list.error, payload: e.response.data });
    }
  };
}

export function instructorConnectionDelete(id) {
  console.log(id);
  return async dispatch => {
    try {
      dispatch({ type: INSTRUCTOR_CONNECTION.loading });

      await request.delete(`/manage/organization/instructor-connections/${id}`);
      dispatch({ type: INSTRUCTOR_CONNECTION.delete, payload: id });
    } catch (e) {
      dispatch({ type: INSTRUCTOR_CONNECTION.error, payload: e.response.data });
    }
  };
}
